import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavbarToggler,
  Collapse,
  NavItem,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import logo from "../assets/govtlogo.png";
import "../App.css";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavOpen: false,
    };
    this.togglenav = this.togglenav.bind(this);
  }

  togglenav() {
    this.setState({
      isNavOpen: !this.state.isNavOpen,
    });
  }

  render() {
    const aadhar = localStorage.getItem("myAadhar");
    const wallet = localStorage.getItem("wallet");
    const isLoggedIn = aadhar && aadhar !== "0";
    const isConnected = wallet && wallet !== "0";

    return (
      <React.Fragment>
        <Navbar dark expand="md" style={{minHeight: '68px'}}>
          <div className="container-fluid px-3 px-md-4 d-flex align-items-center justify-content-between">
            <NavbarToggler onClick={this.togglenav} className="order-1" />
            <NavbarBrand href="#" className="d-flex align-items-center order-0">
              <img src={logo} height="48" width="48" alt="Odisha Govt" style={{borderRadius: '8px'}} />
              <div className="navbar-brand-text">
                <span className="brand-title">LandChain Odisha</span>
                <span className="brand-sub">DST · Govt of Odisha</span>
              </div>
            </NavbarBrand>
            <Collapse isOpen={this.state.isNavOpen} navbar className="order-3">
              <Nav navbar className="mx-auto">
                <NavItem>
                  <NavLink className="nav-link" to="/home">Home</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className="nav-link" to="/allplots">All Plots</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className="nav-link" to="/myplots">My Plots</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className="nav-link" to="/allmem">Members</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className="nav-link" to="/signup">Sign Up</NavLink>
                </NavItem>
              </Nav>
              <div className="user-status-badge">
                <div className="status-label">
                  <span className={`status-dot ${isLoggedIn ? '' : 'offline'}`}></span>
                  {isLoggedIn ? `Aadhar: ${aadhar}` : 'Not Logged In'}
                </div>
                <div className="status-wallet">
                  {isConnected ? `${wallet.substring(0,8)}...${wallet.substring(wallet.length-6)}` : 'Wallet not connected'}
                </div>
              </div>
            </Collapse>
          </div>
        </Navbar>
      </React.Fragment>
    );
  }
}

export default Header;
